import { themeSelectStyles } from "components/shared/theme/themeSelectStyles";
import { ending } from "helpers/i18n";
import { arraysEqual } from "helpers/system";
import debounce from "lodash/debounce";
import React from "react";
import { connect } from "react-redux";
import ReactSelect from "react-select";
import Template from "./template";

const initPag = { start: 0, filters: [] };
const length = 10;

const customStyles = {
    control: (styles) => ({ ...styles, minHeight: "33px", fontSize: "14px" }),
    singleValue: (styles) => ({ ...styles, height: "18px", lineHeight: "18px" }),
    multiValue: (styles) => ({ ...styles, height: "18px", lineHeight: "14px" }),
    valueContainer: (styles) => ({ ...styles, lineHeight: "18px", flexWrap: "nowrap", textAlign: "left" }),
    indicatorsContainer: (styles) => ({ ...styles, height: "31px" }),
    dropdownIndicator: (styles) => ({ ...styles, padding: "6px" }),
    clearIndicator: (styles) => ({ ...styles, padding: "4px" }),
    indicatorSeparator: () => ({ display: "none" }),
    menu: (styles) => ({ ...styles, textAlign: "left" }),
    menuPortal: (styles) => ({ ...styles, zIndex: 105 }),
    option: (styles) => ({ ...styles, fontSize: "14px", textAlign: "left" }),
    placeholder: (styles) => ({ ...styles, lineHeight: "18px", maxWidth: "calc(100% - 16px)", whiteSpace: "nowrap" }),
    input: (styles) => ({ ...styles, height: "17px", paddingTop: 0, marginTop: 0 }),
};

export class Select extends Template {
    _isMounted = false;

    constructor(props) {
        super(props);
        this.debouncedLoadItems = debounce(this.debouncedLoadItems, 1000);
    }

    UNSAFE_componentWillMount() {
        this.setState({
            ...this.state,
            params: initPag,
            isSelect: true,
            isAsyncSelect: !!this.props.url,
            isLoading: false,
            inputValue: "",
            options: [],
            optionsLoaded: false,
            dataIndex: "id",
        });
        this.validate(this.props.value, { isValid: true });
    }

    componentDidMount() {
        this._isMounted = true;
        const { url, value } = this.props;
        if (url) {
            const filters = [{ dataIndex: this.state.dataIndex, value: Array.isArray(value) ? value : [value] }];
            (value ? this.getItems({ ...this.state.params, filters }, true) : Promise.resolve([])).then((data) => {
                const options = this.formatData(data);
                this.setState({ options, isLoading: false });
                this.checkValueExistsInOptions(options, value);
            });
        }
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        const { value, url, isMulti, dataKey } = nextProps;
        if (value !== this.props.value) {
            this.validate(value);
        }
        if (
            url &&
            value &&
            (Array.isArray(value) ? !arraysEqual(value, this.props.value) : value !== this.props.value)
        ) {
            const optionsHasValue = !!this.state.options.find((option) => option.value === value);
            if (!optionsHasValue) {
                const params = {
                    filters: [{ dataIndex: this.state.dataIndex, value: isMulti ? value : [value] }],
                    start: 0,
                };
                this.getItems(params, true).then((data) => this.resHandler(this.state.options.concat(data)));
            }
        }
        if (dataKey !== this.props.dataKey) {
            const options = value
                ? this.state.options.filter((item) => (isMulti ? value.includes(item.value) : item.value === value))
                : [];
            this.setState({ isLoading: true });
            url({ ...initPag, length }).then((data) => this.resHandler(options.concat(data)));
        }
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    checkValueExistsInOptions = (options, value) => {
        if (!value || (Array.isArray(value) && value.length === 0)) {
            return;
        }
        const { isMulti, onNotFoundHandler } = this.props;
        if (isMulti) {
            let hasValue = false;
            if (
                !options.find((option) => {
                    hasValue = value.includes(option.value);
                    return hasValue;
                })
            ) {
                if (onNotFoundHandler) {
                    onNotFoundHandler();
                } else {
                    this.setState({
                        error: "Один или несколько из выбранных элементов не найдены в базе данных",
                        isValid: false,
                    });
                }
            }
        } else {
            if (!options.find((option) => option.value === value) && !this.props.valueKey) {
                if (onNotFoundHandler) {
                    onNotFoundHandler();
                } else {
                    this.setState({ error: "Выбранный элемент не найден в базе данных", isValid: false });
                }
            }
        }
    };

    formatData = (data) => {
        const uniq = {};
        const { propName, idKey } = this.props;
        return data
            .map((item) => {
                if (item.formatted) {
                    return item;
                }
                return {
                    label:
                        typeof propName === "function"
                            ? propName(item)
                            : propName.split(".").reduce((o, key) => (o ? o[key] : undefined), item),
                    value: idKey ? item[idKey] : item.id,
                    isHidden: item.isHidden,
                    formatted: true,
                    option: item,
                };
            })
            .filter(({ value }) => !uniq[value] && (uniq[value] = true));
    };

    setValue = (newValue) => {
        const { inputProps, onChange, isMulti } = this.props;
        this.validate(newValue);
        if (onChange) {
            const value = isMulti ? (newValue || []).map((option) => option.value) : newValue ? newValue.value : null;
            const option = isMulti
                ? (newValue || []).map((option) => option.option)
                : newValue
                  ? newValue.option
                  : null;
            onChange({ name: inputProps.name, value, option });
        }
    };

    getItems = (params, initial = false) => {
        const { minimumInputLength } = this.props;
        const { inputValue } = this.state;
        if (minimumInputLength && minimumInputLength > inputValue.length && !initial) {
            return Promise.resolve([]);
        }
        this.setState({ isLoading: true });
        return this.props.url({ ...params, length });
    };

    resHandler = (options) => {
        if (!this._isMounted) {
            return;
        }
        return this.setState({
            options: this.formatData(options),
            isLoading: false,
            params: { ...this.state.params, elCount: options.length },
        });
    };

    onInputChangeHandler = (value) => {
        const { url, minimumInputLength } = this.props;
        if (
            value && // has value
            this.state.inputValue !== value && // value is changed
            (!this.state.isLoading || !this.state.optionsLoaded) && // is not loading now or options not loaded
            url && // is remote select
            (!minimumInputLength || value.length >= minimumInputLength) // has minimum input length option and his reached
        ) {
            this.setState({ isLoading: true });
            this.debouncedLoadItems();
        }
        this.setState({ inputValue: value });
    };

    debouncedLoadItems = () => {
        const { filterFunc, propName, filterPropName } = this.props;
        const { inputValue } = this.state;
        const dataIndex = filterPropName || propName;
        const filters = filterFunc
            ? [{ dataIndex, value: filterFunc(inputValue) }]
            : [{ dataIndex, value: inputValue }];
        const params = { ...initPag, filters };
        this.getItems(params).then((data) => this.resHandler(this.state.options.concat(data)));
    };

    filterOptions = (options = [], { includeHidden = false } = {}) => {
        const { excludeItems, isGrouped, dictionary } = this.props;
        const list = options || [];
        const withoutGroups = isGrouped ? list : list.map(({ options, ...item }) => item);
        return withoutGroups.filter(
            (item) =>
                (!excludeItems || !excludeItems.includes(item.value)) &&
                (includeHidden || dictionary !== "nDSType" || !item.isHidden),
        );
    };

    getValueOption = (options = [], value) => {
        if (!value) {
            return null;
        }
        const list = options || [];
        const searchList = this.props.isGrouped ? list.flatMap((group) => group.options || []) : list;
        const { valueKey, isMulti } = this.props;
        if (isMulti && !Array.isArray(value)) {
            value = [value];
        }
        const valueOptions = isMulti
            ? searchList.filter((option) => value.includes(valueKey ? option.option[valueKey] : option.value))
            : searchList.find((option) => (valueKey ? option.option[valueKey] : option.value) === value);
        return valueOptions || { label: "", value };
    };

    defaultSelectOptions = () => {
        const {
            theme,
            inputProps,
            unClearable,
            unSearchable,
            value,
            url,
            options,
            styles,
            placeholder,
            minimumInputLength,
            disabled,
            index,
            order,
        } = this.props;
        const tabIndex = this.context?.baseTabIndex || 0;
        const needMoreChars =
            (!value || this.state.inputValue.length > 0) && // without value or user start type chars
            minimumInputLength && // has minimum input length option
            minimumInputLength > this.state.inputValue.length; // minimum input length is not reached
        const rawOptions = (url ? this.state.options : options) || [];
        const valueOptions = needMoreChars ? [] : this.filterOptions(rawOptions, { includeHidden: true });
        const computedOptions = needMoreChars ? [] : this.filterOptions(rawOptions);
        const indexName = index === undefined ? "" : `_${index}`;
        return {
            ...this.props,
            tabIndex: order === undefined ? tabIndex : order + tabIndex,
            onChange: this.setValue,
            options: computedOptions,
            inputValue: this.state.inputValue,
            value: this.getValueOption(valueOptions, value),
            isLoading: this.state.isLoading,
            isClearable: !unClearable,
            isSearchable: !unSearchable,
            placeholder: placeholder || "",
            isDisabled: !!inputProps.disabled || !!disabled,
            loadingMessage: () => <small className="react-select-no-option">Загрузка</small>,
            noOptionsMessage: () => {
                if (needMoreChars) {
                    const remainingChars = minimumInputLength - this.state.inputValue.length;
                    return (
                        <small className="react-select-no-option">
                            Пожалуйста, введите ещё хотя бы {remainingChars} символ
                            {ending(remainingChars, "", "a", "ов")}
                        </small>
                    );
                } else {
                    return <small className="react-select-no-option">Ничего не найдено</small>;
                }
            },
            filterOption: (value, search) => {
                if (this.props.filterOption) {
                    return this.props.filterOption(value, search);
                } else {
                    if (!value.label) {
                        return false;
                    } else {
                        return search
                            .toLowerCase()
                            .split(" ")
                            .every((item) => value.label.toLowerCase().indexOf(item) > -1);
                    }
                }
            },
            onMenuOpen: () => {
                this.props.onMenuOpen?.();
                if (!this.state.optionsLoaded && this.props.url) {
                    this.setState({ isLoading: true });
                    this.getItems({ ...this.state.params, length }).then((data) => {
                        this.resHandler(this.state.options.concat(data));
                        this.setState({ optionsLoaded: true });
                    });
                }
            },
            searchPromptText: "",
            onFocus: this.handleFocus,
            onBlur: this.handleBlur,
            onInputChange: this.onInputChangeHandler,
            classNamePrefix: this.props.classNamePrefix || "react-select",
            styles: {
                ...(theme
                    ? { ...themeSelectStyles(theme, { ...customStyles, ...styles }) }
                    : { ...customStyles, ...styles }),
            },
            id: `${inputProps.name}Container${indexName}`,
            inputId: `${inputProps.name}Input${indexName}`,
            instanceId: `${inputProps.name}Instance${indexName}`,
        };
    };

    renderField = () => <ReactSelect {...this.defaultSelectOptions()} />;
}
const customConnect = (Component) => {
    const mapStateToProps = (state) => {
        return {
            theme: state.layout.theme,
        };
    };

    return connect(mapStateToProps)(Component);
};

export default customConnect(Select);
